// extracted by mini-css-extract-plugin
export default {"resetButton":"VAE8NZX","root":"SrEDUCs","tabs":"UldGcpy"};